import { render, staticRenderFns } from "./zRichEditor.vue?vue&type=template&id=37528cd2&scoped=true"
import script from "./zRichEditor.vue?vue&type=script&lang=js"
export * from "./zRichEditor.vue?vue&type=script&lang=js"
import style0 from "./zRichEditor.vue?vue&type=style&index=0&id=37528cd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37528cd2",
  null
  
)

export default component.exports